import React from 'react';

const TermsAndConditionsFunoAI = () => {
    return (
        <div className="max-w-screen-md mx-auto p-8 bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-300">
            <h1 className="text-3xl font-bold mb-6">Terms and Conditions</h1>

            <p className="text-lg mb-4">
                These Terms and Conditions ("Terms") govern your access to and use of the Funo AI Voice Changer mobile application and related services (collectively, the "Service"). By accessing or using the Service, you agree to be bound by these Terms. If you do not agree with any part of these Terms, please refrain from using the Service.
            </p>

            <h2 className="text-2xl font-semibold mb-4">1. Use of the Service</h2>
            <p className="text-lg mb-4">
                Funo AI Voice Changer provides voice modification, audio processing, and creative effects features. You may use the Service only in compliance with these Terms and all applicable laws. Misuse or unauthorized use may result in termination of your access.
            </p>

            <h2 className="text-2xl font-semibold mb-4">2. Account Registration and Security</h2>
            <p className="text-lg mb-4">
                To access certain features, you may need to create an account. You agree to provide accurate and complete information and to safeguard your device and credentials. You are responsible for all activity that occurs under your account or device. Notify us of any unauthorized use immediately.
            </p>

            <h2 className="text-2xl font-semibold mb-4">3. Intellectual Property Rights</h2>
            <p className="text-lg mb-4">
                Funo AI retains all rights to the content, software, and services offered. You may not reproduce, modify, or distribute any part of the Service without written permission. Unauthorized use may violate copyright or trademark laws.
            </p>

            <h2 className="text-2xl font-semibold mb-4">4. User-Generated Content</h2>
            <p className="text-lg mb-4">
                You may create or upload audio content within the app. By doing so, you grant Funo AI a non-exclusive, worldwide, royalty-free license to use, reproduce, and display such content for the purpose of operating or improving the Service, subject to our Privacy Policy.
            </p>

            <h2 className="text-2xl font-semibold mb-4">5. Privacy and Data Collection</h2>
            <p className="text-lg mb-4">
                We collect and process only essential data, such as your Device ID, as detailed in our Privacy Policy. Use of the app constitutes your consent to such processing. Some anonymous data may be used for in-app purchases and ad personalization.
            </p>

            <h2 className="text-2xl font-semibold mb-4">6. Termination</h2>
            <p className="text-lg mb-4">
                We may suspend or terminate your access to the Service at any time, with or without cause. You may terminate your account and request deletion of your data at any time by contacting us at: <a href="mailto:samedakgul99@gmail.com" className="text-blue-500">samedakgul99@gmail.com</a>.
            </p>

            <h2 className="text-2xl font-semibold mb-4">7. Modifications to the Terms</h2>
            <p className="text-lg mb-4">
                We reserve the right to update these Terms at any time. Changes will be communicated through the app or via app store updates. Continued use of the Service after changes constitutes acceptance of the new Terms.
            </p>

            <h2 className="text-2xl font-semibold mb-4">8. Disclaimers</h2>
            <p className="text-lg mb-4">
                The Service is provided "as is" without warranties of any kind. We do not guarantee uninterrupted availability or error-free performance. Use Funo AI Voice Changer at your own risk and discretion.
            </p>

            <h2 className="text-2xl font-semibold mb-4">9. Limitation of Liability</h2>
            <p className="text-lg mb-4">
                To the fullest extent permitted by law, Funo AI shall not be liable for indirect, incidental, or consequential damages arising from your use of the Service.
            </p>

            <h2 className="text-2xl font-semibold mb-4">Contact Us</h2>
            <p className="text-lg mb-4">
                For questions or support regarding Funo AI Voice Changer, contact us at: <a href="mailto:samedakgul99@gmail.com" className="text-blue-500">samedakgul99@gmail.com</a>.
            </p>
        </div>
    );
};

export default TermsAndConditionsFunoAI;
